import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { languages } from "../../utils/commonUtils";

export const LanguageSelector = () => {
    const { t, i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleLanguageSelection = (newLang) => {
        i18n.changeLanguage(newLang);
        handleClose();
    };

    return (
        <>
            <Button
                className="language-selector"
                aria-controls="language selector"
                aria-haspopup="true"
                onClick={handleClick}
            >
                <span style={{ marginRight: 2 }}>{i18n.language.toUpperCase()}</span>
                <i className="icon-world"></i>
            </Button>
            <Menu id="language-selector" anchorEl={anchorEl} keepMounted open={!!anchorEl} onClose={handleClose}>
                {languages.map(({ id, labelKey }) => (
                    <MenuItem key={id} selected={i18n.language === id} onClick={() => handleLanguageSelection(id)}>
                        {t(labelKey)}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};
